"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SnackBarContent = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _StringHelper = require("../Utilities/StringHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var SnackBarContent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SnackBarContent, _Component);

  var _super = _createSuper(SnackBarContent);

  function SnackBarContent() {
    var _this;

    (0, _classCallCheck2.default)(this, SnackBarContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAction", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          action = _this$props.action;

      if (action) {
        if ( /*#__PURE__*/_react.default.isValidElement(action)) {
          return action;
        } else if ((0, _typeof2.default)(action) === "object") {
          return /*#__PURE__*/_react.default.createElement(_Button.default, {
            id: id ? "".concat(id, "-snackbar-action") : undefined,
            onClick: action.action,
            color: "inherit",
            variant: "outlined",
            size: "small"
          }, action.display);
        } else {
          return new Error("Invalid action provided to SnackBarContent. Must be either a node or an object with action and display keys.");
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          message = _this$props2.message,
          variant = _this$props2.variant,
          className = _this$props2.className,
          fullWidth = _this$props2.fullWidth,
          classes = _this$props2.classes;
      return /*#__PURE__*/_react.default.createElement(_SnackbarContent.default, {
        id: id,
        className: (0, _classnames.default)("prmbl-snackBarContent", className),
        style: fullWidth ? {
          maxWidth: "100vw"
        } : undefined,
        action: _this.renderAction(),
        classes: variant ? {
          root: classes["variant".concat((0, _StringHelper.capitalizeFirstLetter)(variant.toLowerCase()))]
        } : undefined,
        message: message
      });
    });
    return _this;
  }

  return SnackBarContent;
}(_react.Component);

exports.SnackBarContent = SnackBarContent;
(0, _defineProperty2.default)(SnackBarContent, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * If defined, will render a button inside the SnackBarContent to perform the defined action.
   */
  action: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.shape({
    action: _propTypes.default.func,
    display: _propTypes.default.node
  })]),

  /**
   * @ignore
   *
   * root: We had to add this to be able to support the variant prop for color.
   */
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),

  /**
   * The message to display inside the SnackBarContent
   */
  message: _propTypes.default.node,

  /**
   * If defined, will render the snackbar with one of the following styles.
   */
  variant: _propTypes.default.oneOf(["success", "warning", "error", "info"]),

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * Whether the component should fill its parent's width or not
   */
  fullWidth: _propTypes.default.bool
});
(0, _defineProperty2.default)(SnackBarContent, "defaultProps", {
  className: ""
});

var _default = (0, _styles2.withStyles)(_styles.styles)(SnackBarContent);

exports.default = _default;